import CONSTANTS from '../constants';
import AppService from './appService';
import CacheService from './cacheService';
import axios from 'axios';

export default {
  createCheckin,
  fetchCheckins
};

async function createCheckin(doorId) {
  let newAccessToken = await AppService.refreshAccessToken();
  return axios.post(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.CHECKINS}`, { door_id: doorId }, {
    headers: {
      'Business-Name': CacheService.getToken().bname,
      'Access-Token': newAccessToken
    }});
}

async function fetchCheckins(params) {
  let newAccessToken = await AppService.refreshAccessToken();
  return axios.get(`${CONSTANTS.URLS.ROOT}${CONSTANTS.URLS.END_POINTS.CHECKINS}`, {
    params: params,
    headers: {
      'Business-Name': CacheService.getToken().bname,
      'Access-Token': newAccessToken
    }});
}
